import React, { useRef, useState } from 'react';
import FlipBook from 'react-pageflip';
import { Wave } from 'react-animated-text';


import 'tailwindcss/tailwind.css';
import courseOne from '../images/course/course.png'
import bookOne from "../images/course/pageTwo.png"


//icons
import { PiTelevisionBold } from "react-icons/pi";
import { IoIosArrowBack } from "react-icons/io";
import { IoIosArrowForward } from "react-icons/io";
import { RiWhatsappLine } from "react-icons/ri";
import { Link } from 'react-router-dom';




const CourseOne = () => {

    function top() {
        window.scroll(0, 0)
    }

    const bookRef = useRef();

    const handleNext = () => {
        bookRef.current.pageFlip().flipNext();
    };

    const handlePrev = () => {
        bookRef.current.pageFlip().flipPrev();
    };

    return (
        <div className="flex flex-col justify-center items-center w-full  h-screen rounded-md font-[poppins] cursor-grab">
            <FlipBook
                width={310}
                height={460}
                className=""
                ref={bookRef}
            >
                {/* Cover Page */}
                <div className="flex justify-center items-center w-full h-full bg-white border border-gray-300 rounded-r-md md:rounded-l-md md:rounded-r-none">
                    <div>
                        <img src={courseOne} alt="Cover" className=" object-cover w-full rounded-b-sm" />
                    </div>

                    <div>
                        <div className="flex flex-col items-center mt-8">

                            <h3 className="text-[12px] sm:text-[12px] md:text-[14px] mb-4 text-gray-900 uppercase  font-normal border border-gray-400  px-3 py-1 w-fit rounded-md ">
                                Short Term  Courses in
                            </h3>

                            <h3 className=" text-[14px] sm:text-[16px] md:text-[18px] mb-2  font-semibold uppercase font-[Open Sans] text-gray-800">
                                Visual Effects & CG
                            </h3>

                        </div>

                        <div className='flex justify-center items-center mt-4'>

                            <Link to='short-term-course' onClick={top}>
                                <button className="flex items-center  gap-x-2 border rounded-md border-gray-400 hover:scale-105 duration-500 hover:bg-white hover:text-gray-900 shadow-md drop-shadow-md shadow-gray-400  bg-gray-900 text-white text-[10px] sm:text-[12px] md:text-[14px] px-3 py-2 md:py-1.5 md:px-5">
                                    Learn More <IoIosArrowForward className='text-white font-bold text-[14px]' />
                                </button>
                            </Link>
                        </div>
                    </div>
                </div>


                {/* Page 1 */}
                <div className="flex justify-center items-center w-full h-full bg-white border border-gray-300 rounded-r-md">
                    <div className="px-4 py-8 flex flex-col gap-y-10">

                        <div className='flex items-start   h-full gap-x-2'>

                            <div className='bg-white h-4 w-4 md:h-5 md:w-5 shadow-md drop-shadow-md rounded-full flex justify-center items-center'>
                                <PiTelevisionBold className="text-gray-900  p-0.5 h-4 w-4 md:h-5 md:w-5" />
                            </div>


                            <div className=' font-[roboto] '>
                                <h3 className=' font-semibold text-[12px] md:text-[13px]'>Unreal Engine for Filmmakers - 6 Months</h3>

                                {/* <ul className='flex flex-col gap-y-2 list-disc ml-3 mt-4 text-gray-800 text-[12px] md:text-[12px] '>
                                    <li> The course equips filmmakers with essential skills in Unreal Engine for creating advanced visual effects, immersive environments, and previsualization videos for feature film scenes. </li>
                                    <li> Participants will learn real-time rendering techniques, scene creation, and the integration of visual effects to enhance film production with high-quality, dynamic visuals.</li>
                                    <li>Hands-on projects emphasize utilizing Unreal Engine's capabilities to effectively plan and visualize feature film scenes</li>

                                </ul> */}

                            </div>
                        </div>

                        <div className='flex items-start gap-x-2'>

                            <div className='bg-white h-4 w-4 md:h-5 md:w-5 shadow-md drop-shadow-md rounded-full flex justify-center items-center'>
                                <PiTelevisionBold className="text-gray-900  p-0.5 h-4 w-4 md:h-5 md:w-5" />
                            </div>

                            <div className=' font-[roboto]'>
                                <h3 className='font-semibold text-[12px] md:text-[13px]'>Motion Graphics with After Effects & Cinema 4D - 6 Months</h3>

                                {/* <ul className='flex flex-col gap-y-2 list-disc ml-3 mt-2 text-gray-800 text-[12px] md:text-[12px] '>
                                    <li>This course is tailored for aspiring motion graphics artists and animators who wish to master the art of creating dynamic visual content and character animations</li>
                                    <li>This short-term course provides in-depth training on utilizing Adobe After Effects and Cinema 4D to produce professional-grade motion graphics and animated characters.</li>
                                </ul> */}
                            </div>
                        </div>

                        <div className='flex items-start gap-x-2'>

                            <div className='bg-white h-4 w-4 md:h-5 md:w-5 shadow-md drop-shadow-md rounded-full flex justify-center items-center'>
                                <PiTelevisionBold className="text-gray-900  p-0.5 h-4 w-4 md:h-5 md:w-5" />
                            </div>

                            <div className=' font-[roboto]'>
                                <h3 className='font-semibold text-[12px] md:text-[13px]'>Stopmotion Animation - 6 Months</h3>

                                {/* <ul className='flex flex-col gap-y-2 list-disc ml-3 mt-2 text-gray-800 text-[12px] md:text-[12px] '>
                                    <li>This course focuses on teaching the principles and techniques essential for creating captivating animations frame-by-frame.</li>
                                    <li>Students will learn to use industry-standard software - Dragonframe to explore storytelling through animation, and gain hands-on experience in animating characters and objects to bring their creative visions to life.</li>
                                </ul> */}
                            </div>
                        </div>

                        <div className='flex items-start gap-x-2'>

                            <div className='bg-white h-4 w-4 md:h-5 md:w-5 shadow-md drop-shadow-md rounded-full flex justify-center items-center'>
                                <PiTelevisionBold className="text-gray-900  p-0.5 h-4 w-4 md:h-5 md:w-5" />
                            </div>

                            <div className=' font-[roboto]'>
                                <h3 className='font-semibold text-[12px] md:text-[13px]'>Adobe Tools for Filmmakers - 6 Months</h3>

                                {/* <ul className='flex flex-col gap-y-2 list-disc ml-3 mt-2 text-gray-800 text-[12px] md:text-[12px] '>
                                    <li>This course focuses on teaching the principles and techniques essential for creating captivating animations frame-by-frame.</li>
                                    <li>Students will learn to use industry-standard software - Dragonframe to explore storytelling through animation, and gain hands-on experience in animating characters and objects to bring their creative visions to life.</li>
                                </ul> */}
                            </div>
                        </div>

                        <div className='flex items-start gap-x-2'>

                            <div className='bg-white h-4 w-4 md:h-5 md:w-5 shadow-md drop-shadow-md rounded-full flex justify-center items-center'>
                                <PiTelevisionBold className="text-gray-900  p-0.5 h-4 w-4 md:h-5 md:w-5" />
                            </div>

                            <div className=' font-[roboto]'>
                                <h3 className='font-semibold text-[12px] md:text-[13px]'>On-Set Visual Effects Supervisor - 6 Months</h3>

                                {/* <ul className='flex flex-col gap-y-2 list-disc ml-3 mt-2 text-gray-800 text-[12px] md:text-[12px] '>
                                    <li>This intensive course prepares participants to oversee visual effects on film sets, emphasizing pre-production planning, on-set supervision for seamless VFX integration, effective team communication, and real-time problem-solving. </li>
                                    <li> Students will also learn crucial aspects like data handling and the VFX to grade studio roundtrip pipeline, ensuring comprehensive understanding of post-production workflows. </li>
                                    <li>Students will emerge equipped with practical skills and industry knowledge essential for successful careers as on-set visual effects supervisors.</li>
                                </ul> */}
                            </div>
                        </div>



                        {/* <div className='flex items-start   h-full gap-x-2'>

                            <div className='bg-white h-4 w-4 md:h-5 md:w-5 shadow-md drop-shadow-md rounded-full flex justify-center items-center'>
                                <PiTelevisionBold className="text-gray-900  p-0.5 h-4 w-4 md:h-5 md:w-5" />
                            </div>


                            <div className=' font-[roboto]'>
                                <h3 className='font-semibold text-[12px] md:text-[14px]'> 2D Animation Deep Dive</h3>

                                <ul className='flex flex-col gap-y-2 list-disc ml-3 mt-2 text-gray-800 text-[12px] md:text-[14px] '>
                                    <li>Day 1: Introduction to Students and Cinema</li>
                                    <li>Day 2: Language of Cinema</li>
                                    <li>Day 3: Exploring Film Genres</li>
                                    <li>Day 4: Film Analysis</li>
                                    <li>Day 5: Impact of Cinema</li>
                                </ul>

                            </div>
                        </div> */}


                        {/* <div className='flex items-start   h-full gap-x-2'>

                            <div className='bg-white h-4 w-4 md:h-5 md:w-5 shadow-md drop-shadow-md rounded-full flex justify-center items-center'>
                                <PiTelevisionBold className="text-gray-900  p-0.5 h-4 w-4 md:h-5 md:w-5" />
                            </div>

                            <div className=' font-[roboto]'>
                                <h3 className='font-semibold text-[12px] md:text-[14px]'>Introduction to 3D & VFX</h3>

                                <ul className='flex flex-col gap-y-2 list-disc ml-3 mt-2 text-gray-800 text-[12px] md:text-[14px] '>
                                    <li>Day 1: Introduction to Students and Cinema</li>
                                    <li>Day 2: Language of Cinema</li>
                                    <li>Day 3: Exploring Film Genres</li>
                                    <li>Day 4: Film Analysis</li>
                                    <li>Day 5: Impact of Cinema</li>
                                </ul>

                            </div>
                        </div>
                        <div className='flex items-start   h-full gap-x-2'>

                            <div className='bg-white h-4 w-4 md:h-5 md:w-5 shadow-md drop-shadow-md rounded-full flex justify-center items-center'>
                                <PiTelevisionBold className="text-gray-900  p-0.5 h-4 w-4 md:h-5 md:w-5" />
                            </div>


                            <div className=' font-[roboto]'>
                                <h3 className='font-semibold text-[12px] md:text-[14px]'>Project & Portfolio Development</h3>

                                <ul className='flex flex-col gap-y-2 list-disc ml-3 mt-2 text-gray-800 text-[12px] md:text-[14px] '>
                                    <li>Day 1: Introduction to Students and Cinema</li>
                                    <li>Day 2: Language of Cinema</li>
                                    <li>Day 3: Exploring Film Genres</li>
                                    <li>Day 4: Film Analysis</li>
                                    <li>Day 5: Impact of Cinema</li>
                                </ul>

                            </div>
                        </div> */}

                    </div>
                </div>


                {/* Page 2 */}
                {/* <div className="flex justify-center items-center w-full h-full bg-white border border-gray-300 rounded-r-md md:rounded-l-md md:rounded-r-none">
                    <div className="px-4 py-8 flex flex-col gap-y-10">

                        <div className='flex items-start gap-x-2'>

                            <div className='bg-white h-4 w-4 md:h-5 md:w-5 shadow-md drop-shadow-md rounded-full flex justify-center items-center'>
                                <PiTelevisionBold className="text-gray-900  p-0.5 h-4 w-4 md:h-5 md:w-5" />
                            </div>

                            <div className=' font-[roboto]'>
                                <h3 className='font-semibold text-[12px] md:text-[14px]'>Motion Graphics with After Effects & Cinema 4D - 6 Months</h3>

                                <ul className='flex flex-col gap-y-2 list-disc ml-3 mt-2 text-gray-800 text-[12px] md:text-[12px] '>
                                    <li>This course is tailored for aspiring motion graphics artists and animators who wish to master the art of creating dynamic visual content and character animations</li>
                                    <li>This short-term course provides in-depth training on utilizing Adobe After Effects and Cinema 4D to produce professional-grade motion graphics and animated characters.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div> */}

                {/* Page 3 */}
                {/* <div className="flex justify-center items-center w-full h-full bg-white border border-gray-300 rounded-r-md">
                    <div className="px-4 py-8 flex flex-col gap-y-10">

                        <div className='flex items-start gap-x-2'>

                            <div className='bg-white h-4 w-4 md:h-5 md:w-5 shadow-md drop-shadow-md rounded-full flex justify-center items-center'>
                                <PiTelevisionBold className="text-gray-900  p-0.5 h-4 w-4 md:h-5 md:w-5" />
                            </div>

                            <div className=' font-[roboto]'>
                                <h3 className='font-semibold text-[12px] md:text-[14px]'>Stopmotion Animation - 6 Months</h3>

                                <ul className='flex flex-col gap-y-2 list-disc ml-3 mt-2 text-gray-800 text-[12px] md:text-[12px] '>
                                    <li>This course focuses on teaching the principles and techniques essential for creating captivating animations frame-by-frame.</li>
                                    <li>Students will learn to use industry-standard software - Dragonframe to explore storytelling through animation, and gain hands-on experience in animating characters and objects to bring their creative visions to life.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div> */}

                {/* Page 4 */}
                {/* <div className="flex justify-center items-center w-full h-full bg-white border border-gray-300 rounded-r-md md:rounded-l-md md:rounded-r-none">
                    <div className="px-4 py-8 flex flex-col gap-y-10">

                        <div className='flex items-start gap-x-2'>

                            <div className='bg-white h-4 w-4 md:h-5 md:w-5 shadow-md drop-shadow-md rounded-full flex justify-center items-center'>
                                <PiTelevisionBold className="text-gray-900  p-0.5 h-4 w-4 md:h-5 md:w-5" />
                            </div>

                            <div className=' font-[roboto]'>
                                <h3 className='font-semibold text-[12px] md:text-[14px]'>Adobe Tools for Filmmakers - 6 Months</h3>

                                <ul className='flex flex-col gap-y-2 list-disc ml-3 mt-2 text-gray-800 text-[12px] md:text-[12px] '>
                                    <li>This course covers fundamentals of Adobe Premiere Pro for editing, After Effects for creating motion graphics and visual effects, Photoshop for image editing and compositing, Illustrator for designing graphics and titles, and Lightroom for color correction and photo enhancement.</li>
                                    <li>Students learn to integrate these tools into their filmmaking workflow, from editing raw footage to adding special effects and creating polished final outputs.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div> */}

                {/* Page 4 */}
                {/* <div className="flex justify-center items-center w-full h-full bg-white border border-gray-300 rounded-r-md">
                    <div className="px-4 py-8 flex flex-col gap-y-10">

                        <div className='flex items-start gap-x-2'>

                            <div className='bg-white h-4 w-4 md:h-5 md:w-5 shadow-md drop-shadow-md rounded-full flex justify-center items-center'>
                                <PiTelevisionBold className="text-gray-900  p-0.5 h-4 w-4 md:h-5 md:w-5" />
                            </div>

                            <div className=' font-[roboto]'>
                                <h3 className='font-semibold text-[12px] md:text-[14px]'>On-Set Visual Effects Supervisor - 6 Months</h3>

                                <ul className='flex flex-col gap-y-2 list-disc ml-3 mt-2 text-gray-800 text-[12px] md:text-[12px] '>
                                    <li>This intensive course prepares participants to oversee visual effects on film sets, emphasizing pre-production planning, on-set supervision for seamless VFX integration, effective team communication, and real-time problem-solving. </li>
                                    <li> Students will also learn crucial aspects like data handling and the VFX to grade studio roundtrip pipeline, ensuring comprehensive understanding of post-production workflows. </li>
                                    <li>Students will emerge equipped with practical skills and industry knowledge essential for successful careers as on-set visual effects supervisors.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div> */}

                {/* Page 5 */}
                {/* <div className="flex justify-center items-center w-full h-full bg-white border border-gray-300 rounded-r-md md:rounded-l-md md:rounded-r-none overflow-hidden">
                    <div>
                        <img src={bookOne} alt="Cover" className=" object-cover w-full rounded-r-md md:rounded-l-md md:rounded-r-none " />
                    </div>
                </div> */}

                {/* Page 6 */}
                {/* <div className="flex justify-center items-center w-full h-full bg-white border border-gray-300 rounded-r-md">
                    <div className='px-4 py-8 flex flex-col gap-y-10 justify-center items-center my-auto h-full'>

                        <div>
                            <h3 className='text-[18px]  font-semibold text-center uppercase'>Film Your Future with Us</h3>
                        </div>
                        <div className='mt-4 flex justify-center items-center'>
                            <a
                                href="https://api.whatsapp.com/send?phone=9884683888"
                                target="_blank"
                                rel="noopener noreferrer"

                            >
                                <button
                                    className={`bg-gray-900 text-white shadow-md drop-shadow-md h-9 pl-3 rounded-md flex items-center gap-x-3 font-[poppins] text-[12px] md:text-[14px] hover:scale-105 duration-500 `}
                                >
                                    Download syllabus
                                    <div className='px-3 bg-green-600 rounded-r-md'>
                                        <RiWhatsappLine className='text-white h-9 text-[22px] font-bold' />
                                    </div>
                                </button>
                            </a>
                        </div>
                    </div>
                </div> */}


            </FlipBook >
            <div className="mt-4 flex space-x-4">

                <button onClick={handlePrev} className="flex items-center gap-2 border rounded-md border-gray-900 hover:scale-105 duration-500 hover:bg-white hover:text-gray-900   text-gray-900 text-[10px] sm:text-[12px] md:text-[14px] px-3 py-2 md:py-2 md:px-4">
                    <IoIosArrowBack className='text-gray-900' />
                </button>

                <button onClick={handleNext} className="flex items-center gap-2 border rounded-md border-gray-900 hover:scale-105 duration-500 hover:bg-white hover:text-gray-900   text-gray-900 text-[10px] sm:text-[12px] md:text-[14px] px-3 py-2 md:py-2 md:px-4">
                    <IoIosArrowForward className='text-gray-900' />
                </button>

            </div>
        </div >
    );
};

export default CourseOne;
